import {Checkbox, Col, Icon, Row, Tooltip} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { LocalStorageKey, PageRoute } from "../../../models";
import {
  createDefaultValueObject,
  isObject,
  localStorage,
  parseFormControlValue
} from "../../../services";
import styles from "./multiFieldSelectorCheckBox.scss";
import moment from "moment";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";


const MultiFieldSelectorCheckBox = React.forwardRef((props: any, ref) => {
  const {
    options,
    title,
    multiValue,
    bold,
    isRequired,
    isSearch,
    alignCheckbox
  } = props;

  
  const location = useLocation();
  const pathnameSegments = [ PageRoute.postAd, PageRoute.editAd ];

  const [disabled, setDisabled] = useState(false);
  const [fields, setFields] = useState([]);
  const defaultValue = createDefaultValueObject(fields);
  

  useEffect(() => {
    setFields(options.map(opt => opt.field));
  }, []);


  function getValue() {
    const { value } = props;
    const values = [];

    isObject(value) &&
      Object.keys(value).forEach(property => {
        if (value[property]) {
          values.push(property);
        }
      });
  
    

    return values;
  }

  const handleChange = values => {
    const { onChange } = props;

    const parsedValue = parseFormControlValue(
      values,
      Array(values.length).fill(true)
    );

    const defaultValue = createDefaultValueObject(fields);

    if (multiValue) {
      const parsed = parseFormControlValue(
        Object.keys(defaultValue),
        Array(values.length).fill(true)
      );

      if (JSON.stringify(values) != JSON.stringify([])) {
        onChange({ ...props.value, ...parsed });
      }
    } else {
      if (!parsedValue && fields.includes('validDataGuarantee')) {
        return
      }

      onChange({ ...defaultValue, ...parsedValue });
    }
  };

  return (
    <React.Fragment>
      {!isSearch && title && <span className={styles.title}>{title}</span>}
      <Checkbox.Group
        className={styles.checkboxWrapper}
        value={getValue()}
        onChange={handleChange}
        style={{ height: "100%" }}
      >
        <Row
          type="flex"
          align="top"
          className={styles.row}
          style={{ alignItems: options.length == 1 ? "flex-end" : "unset" }}
        >
          {options.map((option, index) =>
            options.length == 1 ? (
              <div
                key={index}
                className={styles.singleCheckbox}
                style={{
                  margin: `${isSearch ? "10px 0 10px 0" : ""}`,
                  padding: `${!isSearch && "0 0 20px 0"}`
                }}
              >
                <Checkbox
                  style={{ fontWeight: `${bold ? "bold" : "unset"}` }}
                  disabled={disabled}
                  value={disabled ? defaultValue : option.field}
                  className={alignCheckbox ? styles.alignCheckbox : null}
                >
                  <span className={`${isRequired ? "required" : ""}`}>
                    {option.title}
                    {option.tooltip && (
                        <Tooltip title={option.tooltip} placement="top">
                          <Icon
                              className={styles.infoIcon}
                              type="info-circle-o"
                          />
                        </Tooltip>
                    )}
                  </span>
                </Checkbox>
              </div>
            ) : options.length == 2 ? (
              <Col key={index} span={12}>
                <Checkbox value={option.field}>{option.title} {option.tooltip && (
                    <Tooltip title={option.tooltip} placement="top">
                      <Icon
                          className={styles.infoIcon}
                          type="info-circle-o"
                      />
                    </Tooltip>
                )}</Checkbox>
              </Col>
            ) : (
              <Col
                key={index}
                lg={8}
                sm={12}
                xs={24}
                style={{ margin: "10px 0" }}
              >
                <Checkbox value={option.field}>{option.title} {option.tooltip && (
                    <Tooltip title={option.tooltip} placement="top">
                      <Icon
                          className={styles.infoIcon}
                          type="info-circle-o"
                      />
                    </Tooltip>
                )}</Checkbox>
              </Col>
            )
          )}
        </Row>
      </Checkbox.Group>
    </React.Fragment>
  );
});

MultiFieldSelectorCheckBox.defaultProps = {
  isSearch: false
};

export default MultiFieldSelectorCheckBox;



// WEBPACK FOOTER //
// ./src/components/FormControls/MultiFieldSelectorCheckBox/MultiFieldSelectorCheckBox.tsx